
import { Mixins, Component, Ref, Watch } from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import Resize from "@/mixins/resize";
import GetMerchantByRemote from "@/mixins/getMerchantByRemote";
import { Form } from "element-ui/types";
import ETable from '@/components/ETable.vue';
import UploadExcel from "@/components/uploadExcel.vue";
import config from "@/config/default";

@Component({ name: 'product-import-index',
  components: { ETable, UploadExcel }
})
export default class ProductImport extends Mixins(tablePagination, loading, Resize, GetMerchantByRemote) {
  @Ref("validateForm") formRef: Form;
  @Ref("uploadExcelRef") uploadExcelRef: UploadExcel;

  formData = {
    merchantId: "",
    file: []
  };

  rules = {
    merchantId: [
      { required: true, message: "请选择品牌方", trigger: "change" },
    ],
    file: [
      { required: true, message: "请上传文件", trigger: "change" },
    ]
  };

  columns = [
    { label: "ID", prop: "id", width:"100", align: "center" },
    { label: "产品信息", prop: "name", align: "center", },
    { label: "操作人", prop: "modifiedBy", align: "center" },
  ]

  tableData = [];

  uploadUrl = "";

  mounted() {
    this.windowResize();
  }

  importProduct() {
    this.formRef?.validate().then((valid) => {
      this.uploadExcelRef?.uploadExcelRef?.submit();
    })
  }

  syncProductList(e) {
    this.tableData = e;
  }

  @Watch("formData.merchantId")
  merchantIdChange(val) {
    this.uploadUrl = `${config.baseUrl}/prescription/presCategory/import/${val}`
  }
}
